$(document).ready(function() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if ($(window).scrollTop() > 200) {
            $('.headerWrapper').addClass('active');
            $('.whiteLogo').addClass('defaultLogo');
        } else {
            $('.headerWrapper').removeClass('active');
            $('.whiteLogo').removeClass('defaultLogo');
        }
    });
});